import AssetUpload from 'components/AssetUpload';
import { Card, Form, Input } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { ITestimonial } from 'interfaces/testimonials';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const TestimonialCreate = () => {
  const { formProps, saveButtonProps } = useForm<ITestimonial>();

  return (
    <CreateLayout saveButtonProps={saveButtonProps} title="Criar depoimento">
      <PageHeader title="Criar depoimento" icon={EcommerceIconComponent} />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Imagem para depoimento"
            name="image"
            rules={[
              {
                required: false
              }
            ]}
          >
            <AssetUpload accept="image/png, image/jpeg" type="testimonial" />
          </Form.Item>
          <Form.Item
            label="Título"
            name="title"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Subtítulo"
            name="subtitle"
            rules={[
              {
                required: false
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
